module.exports = __webpack_public_path__ + "img/ic_check_success.d9436f69.svg";